// extracted by mini-css-extract-plugin
module.exports = {"container":"Style_container__3lN6t","bcicon":"Style_bcicon__3kDdR"};